import React from 'react';
import FormGroup from '@material-ui/core/FormGroup';

import { AppSwitch } from '@coreui/react';
import './JirangoSwitch.css'

export default function JirangoSwitch({onChange,isChecked}) {
  return (
     <AppSwitch onChange={onChange} checked={isChecked} className={'mx-1 switch-sm jirango-switch'} variant={'3d'} color={'success'} />
  );
}